import React from 'react'
import { FaStar, FaStarHalfAlt, FaRegStar} from 'react-icons/fa';
import "./StarRating.scss"

function StarRating({rating, onRatingChange }) {


 
  const totalStars = 5;

  const handleClick = (value) => {
    onRatingChange(value);
  };
  return (
    <div className="star-container">
    {[...Array(totalStars)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={starValue}
          onClick={() => handleClick(starValue)}
          style={{ cursor: 'pointer' }}
        >
          {rating >= starValue ? (
            <FaStar size={25} className='FullStar' />
          ) : rating >= starValue - 0.5 ? (
            <FaStarHalfAlt size={25} className='HalfStar' />
          ) : (
            <FaRegStar size={25} className='EmptyStar' />
          )}
        </span>
      );
    })}
  </div>
  )
}

export default StarRating
